const defaultCss = `
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }
  h1 {
    font-size: 2em;
    font-weight: bold;
  }
  h2 {
    font-size: 1.5em;
    font-weight: bold;
  }
  h3 {
    font-size: 1.17em;
    font-weight: bold;
  }
  h4 {
    font-size: 1em;
    font-weight: bold;
  }
  h5 {
    font-size: 0.83em;
    font-weight: bold;
  }
  h6 {
    font-size: 0.67em;
    font-weight: bold;
  }
  a {
    color: inherit;
    text-decoration: none;
  }
  audio, canvas, embed, iframe, img, object, svg, video {
    max-width: 100%;
    height: auto;
    display: block;
    vertical-align: middle;
  }
  table {
    max-width: 100%;
    border-top: 1px solid #ccc;
    border-left: 1px solid #ccc;
    box-sizing: border-box;
    border-collapse: collapse;
    text-indent: 0;
  }
  table tbody tr th, 
  table thead tr th, 
  table tbody tr td,
  table thead tr td {
    border-bottom: 1px solid #d9d9d9;
    border-right: 1px solid #d9d9d9;
    padding: 3px 5px;
    height: 30px; /* CSS 2.1 规范中明确规定：min-height 属性 不适用于表格单元格（td、th）。*/
  }
  table tbody tr th,
  table thead tr th {
    text-align: center;
    background-color: #f1f1f1;
  }
  ol {
    margin: 10px 0 10px 30px;
    li {
      list-style-type: decimal;
    }
  }
  ul {
    margin: 10px 0 10px 20px;
    li {
      list-style-type: disc;
    }
  }
  blockquote {
    display: block;
    border-left: 8px solid #d0e5f2;
    padding: 5px 10px;
    margin: 10px 0;
    line-height: 1.4;
    font-size: 100%;
    background-color: #f1f1f1;
  }
  code {
    display: inline-block;
    background-color: #f1f1f1;
    border-radius: 3px;
    padding: 3px 5px;
    margin: 0 3px;
  }
  pre code {
    display: block;
  }
  i {
    font-style: italic;
  }
  b,
  strong {
    font-weight: bold;
  }
  em {
    font-style: italic;
  }
  sup {
    vertical-align: super;
    font-size: smaller;
  }
  sub {
    vertical-align: sub;
    font-size: smaller;
  }
`;

export default defaultCss;
